<ion-list
  [attr.class]="hostClassString"
  [lines]="lines"
  [inset]="inset"
  [mode]="mode"
  [attr.inert]="disabled ? '' : null"
  [class.crowdctrl-list--disabled]="disabled"
>
  <ng-content />
  @if (showLoadMore) {
    <div class="crowdctrl-list__load-more">
      <crowdctrl-loading-button
        type="button"
        expand="block"
        fill="outline"
        [loading]="loadMoreLoading"
        [loadingText]="loadMoreLoadingText"
        [disabled]="!loadMoreHasNext"
        (pressed)="loadMoreClick.emit()"
      >
        {{ loadMoreLabel }}
      </crowdctrl-loading-button>
    </div>
  }
  <ng-content select="crowdctrl-pagination-footer" />
</ion-list>
